import { OrderData as CoreOrderData, Promise as BluebirdPromise } from '@ambita/ambita-components-core';
import { fetchOrder } from './common';
import { fetchOwnerDataForCadastreWithOwningCadastres } from './neighborList';
import { Order, OrderData } from '../typings/Order';
import { OwnerData } from '../typings/OwnerList';

export const fetchReportData = async (orderId: string): BluebirdPromise<CoreOrderData.Data> => {
  return fetchOrder(orderId).then((order: Order) => {
    return fetchAndComposeReportData(order.orderData);
  });
};

const fetchAndComposeReportData = async (orderData: CoreOrderData.Data): BluebirdPromise<OrderData> => {
  const reportData: OrderData = {
    geojson: orderData.geojson
  };

  reportData.owners = await fetchOwnerDataForCadastreWithOwningCadastres(orderData.eiendommer);

  return reportData;
};

const getCorrectOwnerAddress = (address: OwnerData): string => {
  if (!address.address && !address.location.street) {
    return '';
  } else if (address.address) {
    return address.address.title;
  } else if (address.location.street) {
    return address.location.street + ' ' + address.location.addressNumber;
  }
};

const getCorrectPostalCode = (postalCode: OwnerData): string => {
  if (!postalCode.address && !postalCode.location.postalCode) {
    return '';
  } else if (postalCode.address) {
    return postalCode.address.postcode;
  } else if (postalCode.location.postalCode) {
    return String(postalCode.location.postalCode);
  }
};

const getCorrectPostalPlace = (postalPlace: OwnerData): string => {
  if (!postalPlace.address && !postalPlace.location.postalPlace) {
    return '';
  } else if (postalPlace.address) {
    return postalPlace.address.city;
  } else if (postalPlace.location.postalPlace) {
    return postalPlace.location.postalPlace;
  }
};

export const generateCSV = (reportData: OrderData): string => {
  const csvRows = [];
  const csvColumnHeaders = [
    'Kommunenummer', 'Gårdsnummer', 'Bruksnummer', 'Festenummer', 'Seksjonsnummer',
    'Eiendommens Adresse', 'Eiendommens Postnummer', 'Eiendommens Poststed',
    'Navn', 'Andel Teller', 'Andel Nevner',
    'Eier Adresse', 'C/O-adresse', 'Eiers Postnummer', 'Eiers Poststed',
    'Rolle'
  ];

  csvRows.push(csvColumnHeaders);

  reportData.owners.forEach((owner: OwnerData) => {
    csvRows.push([
      owner.cadastre.knr, owner.cadastre.gnr, owner.cadastre.bnr, owner.cadastre.fnr, owner.cadastre.snr,
      owner.cadastreAddress.title, owner.cadastreAddress.postcode, owner.cadastreAddress.city,
      owner.name, owner.fraction.numerator, owner.fraction.denominator,
      getCorrectOwnerAddress(owner), owner.coAddress, getCorrectPostalCode(owner),
      getCorrectPostalPlace(owner),
      owner.role
    ]);
  });

  return csvRows.map((csvRow) => {
    return `"${csvRow.join('";"')}"`;
  }).join('\r\n');
};
